import React from "react";
import { useBetslipStore } from "@/features/betslip/stores/betslipStore";
import { Empty } from "@/features/betslip/components/Empty";
import { SlipSections } from "@/features/betslip/components/SlipSections";

import * as styles from "./SlipBody.module.scss";

export const SlipBody = () => {
  const isEmpty = useBetslipStore((state) => state.selectionsCount === 0);

  return (
    <div data-testid="slip-body" className={styles.slipBody}>
      {isEmpty ? <Empty /> : <SlipSections />}
    </div>
  );
};
